<section class="legal-page">
  <div class="container">
    <header class="legal-page__head mb-10">
      <h1 class="legal-page__title fw-bolder mb-3">{{ titleKey | translate }}</h1>
      <p class="legal-page__updated m-0">{{ updatedKey | translate }}</p>
    </header>

    @if (introKey) {
    <p class="legal-page__intro mb-10" [innerHTML]="introKey"></p>
    }

    @for (section of sections; track section.id ?? section.name; let idx = $index) {
    <div class="legal-page__section fs-5">
      <h3 class="legal-page__section-title fs-5 fw-bolder text-gray-800">{{ idx + 1 }}. {{ section.name }}</h3>
      <div class="legal-page__body" [innerHTML]="section.content"></div>
    </div>
    }

    @if (demo.enabled) {
    <p class="legal-page__note mt-12 pt-5 fs-8 fst-italic">{{ "LEGAL.DEMO_NOTE" | translate }}</p>
    }
  </div>
</section>